<div class="responsive-contr">
  <div class="container mob body">
    <div class="download">
      <div class="row">
        <div class="col-4">
          <div
            class="app-logo"
            style="
              background-image: url(../../../../assets/images/nadel-icon.webp);
            "></div>
        </div>
        <div class="col-8">
          <div class="app-header has-logo pt-4">
            <h1>Nadel Sales Mobile App</h1>
          </div>
        </div>
      </div>
      <div class="col-lg-12 pt-4">
        <a href="/sales-mobile-app" class="back-link router-link-active"
          >Go back</a
        >
        <h3>
          <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="fas"
            data-icon="info-circle"
            role="img"
            viewBox="0 0 512 512"
            class="icon svg-inline--fa fa-info-circle fa-w-16">
            <path
              fill="currentColor"
              d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"
              class=""></path></svg
          >Instructions
        </h3>
        <ol class="instructions">
          <li>
            Accept the download and wait for it to finish.
            <svg
              class="download-prompt-overlay"
              viewBox="0 0 540 297"
              class="instruction-image">
              <image
                xlink:href="../../../../assets/images/ios-app-step-1.png"
                width="100%"
                height="100%"
                x="0"
                y="0"></image>
              <text x="270" y="120" font-size="35" text-anchor="middle">
                "Nadel Mobile App"
              </text>
            </svg>
          </li>
          <li>
            If it's your first time installing an app from Nadel, you'll need to
            perform a couple more steps. First, open the Settings app.
            <img
              src="../../../../assets/images/ios-step-3.png"
              style="width: 1.4em; vertical-align: top"
              alt="" />
          </li>
          <li>
            Navigate to
            <strong>General</strong>
            <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="fas"
              data-icon="arrow-right"
              role="img"
              viewBox="0 0 448 512"
              class="svg-inline--fa fa-arrow-right fa-w-14">
              <path
                fill="currentColor"
                d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"
                class=""></path>
            </svg>
            <strong>VPN & Device Management</strong>
            <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="fas"
              data-icon="arrow-right"
              role="img"
              viewBox="0 0 448 512"
              class="svg-inline--fa fa-arrow-right fa-w-14">
              <path
                fill="currentColor"
                d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"
                class=""></path>
            </svg>
            <strong>Jack Nadel inc</strong>
          </li>
          <li>
            Click to trust this publisher, then accept the confirmation. Now
            you're all set to use the app!
            <svg
              class="trust-overlay"
              viewBox="0 0 750 143"
              class="instruction-image">
              <image
                xlink:href="../../../../assets/images/ios-app-step-4.png"
                width="100%"
                height="100%"
                x="0"
                y="0"></image>
              <text x="375" y="86" font-size="38" text-anchor="middle">
                Trust "Jack Nadel inc"
              </text>
            </svg>
          </li>
          <!---->
        </ol>
      </div>
    </div>
  </div>
</div>
